import { compose } from 'recompose';

import Payment from './Payment';

import apiInterceptor from '../../../api/interceptor';

import { paymentApi } from '../../common/base.api';

const composedReceipt = compose(apiInterceptor({ ...paymentApi }))(Payment);

export default composedReceipt;
